<template>
  <div class="club-summary">
    <div class="club-summary__title-wrap">
      <h2 class="club-summary__title">
        Клубная программа
      </h2>

      <div
        v-if="IS_EMPLOYEE"
        class="club-summary__employee-state"
      >
        {{ LEVEL_NAME }}
      </div>
    </div>

    <div class="club-summary__card-wrap-outter">
      <div class="club-summary__card-wrap">
        <f-sprite-icon
          class="club-summary__card"
          :icon-link="$options.icons.ImageCard.id"
        />
        <div class="club-summary__card-id-title">
          Номер клубной карты
        </div>
        <div class="club-summary__card-id">
          {{ USER_BONUS_CARD_NUMBER }}
        </div>
      </div>
    </div>

    <div class="club-summary__points-wrap">
      <div class="club-summary__points-title">
        Доступно
      </div>
      <div
        class="club-summary__points"
      >
        {{ BONUSES | price }}&nbsp;<span class="club-summary__points-caption">{{ BONUSES | decl('бонус', ['', 'а', 'ов']) }}</span>
      </div>
    </div>

    <div class="club-summary__detalization">
      <div v-if="!IS_EMPLOYEE">
        <div
          class="club-summary__detalization-caption"
        >
          из них
        </div>

        <div
          class="club-summary__detalization-inner"
        >
          <club-points-detail
            tooltip="Начисляются за покупку товара, на который не установлена и не применена скидка"
            :is-promotion="false"
            class="club-summary__detalization-item"
            title="за покупки"
            :date="CASHBACK_BONUS.expireAt"
            :points="CASHBACK_BONUS.amount || 0"
            :points-burns="CASHBACK_BONUS.expiringAmount || 0"
          />
          <club-points-detail
            tooltip="Начисляются в период специальных акций в объёме, оговорённом в условиях акций"
            class="club-summary__detalization-item"
            is-promotion
            title="за покупки"
            :points="totalPromoBonuses"
            :date="promoFirstEnds.dateEnd || ''"
            :points-burns="promoFirstEnds.bonuses || 0"
          />
        </div>
      </div>
      <div v-else>
        <club-summary-burns
          v-if="IS_EMPLOYEE"
          :points="promoFirstEnds.bonuses || 0"
          :date="promoFirstEnds.dateEnd || ''"
        />
      </div>
    </div>

    <div class="club-summary__info">
      <ui-link href="/fun-club">
        Программа лояльности
      </ui-link> FUNDAY дает участникам специальные привилегии,
      дополнительные скидки и уникальные предложения.
    </div>

    <phone-edit class="club-summary__phone-edit" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ImageCard from '@images/card.multi.svg';
import ClubPointsDetail from '@/components/account/club-points-detail.vue';
import PhoneEdit from '@/components/account/phone-edit.vue';
import ClubSummaryBurns from '@/components/account/club-summary-burns.vue';
import { ddmmyyyy } from '@/utils/date-to-string';

export default {
  name: 'club-summary',

  icons: {
    ImageCard,
  },

  components: {
    ClubPointsDetail,
    PhoneEdit,
    ClubSummaryBurns,
  },

  computed: {
    ...mapState('club',{
      USER_BONUS_CARD_NUMBER: 'cardNumber',
      IS_EMPLOYEE: 'isEmployee',
      LEVEL_NAME: 'currentLevelName',
    }),
    ...mapGetters({
      PROMOS_SORT_BY_END: 'user/promosSortByEnd',
      BONUSES: 'user/bonuses',
      CASHBACK_BONUS: 'user/cashbackBonus',
      promoBonusesAtDate: 'user/promoBonusesAtDate',
    }),
    account() {
      return this.$store.state.user.account
    },
    promoFirstEnds() {
      return this.PROMOS_SORT_BY_END[0] || {};
    },
    totalPromoBonuses() {
      return this.promoBonusesAtDate(new Date());
    },
    employeeExpiresAt() {
      return ddmmyyyy(new Date(this.CASHBACK_BONUS.expireAt));
    },
  },
}
</script>

<style lang="scss">
  .club-summary {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 12px;
    background: $white;
    border: 1px solid $gray_lu;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04),
                0 8px 24px rgba(0, 0, 0, .03),
                0 16px 32px rgba(0, 0, 0, .02);
    border-radius: 4px;

    @include breakpoint("tablet") {
      padding: 16px;
    }

    &__title-wrap {
      @include breakpoint("tablet") {
        margin-bottom: 20px;
      }

      @include breakpoint("desktop") {
        margin-bottom: 28px;
      }
    }

    & &__title {
      font-size: 20px;
      line-height: 28px;
      font-weight: 300;
    }

    &__detalization-caption {
      @include breakpoint("tablet") {
        font-size: 14px;
      }
    }

    &__employee-state {
      font-weight: 400;
      font-size: 16px;
      line-height: 48px;
      color: $gray;

      @include breakpoint("tablet") {
        font-size: 18px;
      }
    }

    &__card-id-title {
      display: none;
      color: $gray;
      font-size: 12px;
      line-height: 24px;

      @include breakpoint("tablet") {
        display: block;
      }
    }

    &__card-id {
      font-family: Gilroy, sans-serif;
      font-weight: 400;
      font-size: 10px;
      line-height: 25px;

      @include breakpoint("tablet") {
        font-size: 14px;
        line-height: 22px;
      }
    }

    &__card-wrap-outter {
      display: flex;
      justify-content: flex-end;
      @include breakpoint("tablet") {
        grid-column: 3;
        grid-row: 1/4;
      }
    }

    &__card-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    svg.club-summary__card {
      width: 74px;
      height: 48px;
      display: inline-block;

      @include breakpoint("tablet") {
        margin-bottom: 11px;
        width: 168px;
        height: 108px;
      }

      @include breakpoint("desktop") {
        width: 220px;
        height: 144px;
      }
    }

    &__points-wrap {
      grid-column: 1 / 3;
      grid-row: 2;
      margin-top: 25px;

      @include breakpoint("tablet") {
        margin-top: 0;
      }
    }

    &__head {
      display: flex;
      justify-content: space-between;
    }

    &__points-title {
      font-family: Gilroy, sans-serif;
      color: $gray;
      font-size: 12px;
      line-height: 20px;
      margin-bottom: 10px;

      @include breakpoint("tablet") {
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 7px;
      }
    }

    &__points {
      color: $blue;
      font-size: 48px;
      line-height: 40px;
      font-weight: bold;
      margin-bottom: 5px;

      @include breakpoint("tablet") {
        font-size: 56px;
        line-height: 48px;
      }
    }

    &__points-caption {
      font-size: 16px;

      @include breakpoint("tablet") {
        font-size: 20px;
        line-height: 48px;
      }
    }

    &__detalization {
      grid-column: 1 / 3;
      grid-row: 3;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      color: $gray;
      margin-bottom: 28px;

      &-caption {
        font-size: 12px;
        line-height: 20px;
        margin-bottom: 15px;

        @include breakpoint("tablet") {
          margin-bottom: 12px;
        }
      }

      &-inner {
        @include breakpoint("tablet") {
          display: flex;
        }
      }

      &-item {
        margin-bottom: 16px;

        @include breakpoint("tablet") {
          margin-right: 12px;
          margin-bottom: 0;
          flex: 1;
          max-width: 236px;

          &:last-child {
            margin-right: 0;
          }
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &__info {
      grid-column: 1 / 3;
      grid-row: 4;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 36px;

      @include breakpoint("tablet") {
        padding-top: 24px;
        margin-right: 60px;
      }

      @include breakpoint("desktop") {
        font-size: 16px;
      }
    }

    &__phone-edit {
      grid-column: 1 / 3;
      grid-row: 5;

      @include breakpoint("tablet") {
        grid-column: 3/4;
        grid-row: 4;
      }
    }
  }
</style>